import { useEffect } from "react";
import { UserData } from "../types/user-data";
import { base64ToUtf8 } from "utils/encoding";

interface NativeAuthOptions {
    onSessionReceived: (userData: UserData) => void;
}

export const useNativeAuthListener = ({ onSessionReceived }: NativeAuthOptions) => {
    useEffect(() => {
        // Inicializar el namespace
        window.CarriApp = window.CarriApp || {};

        // Definir la función que Android llamará
        window.CarriApp.injectSession = (data: string | object) => {
            if(!data)
                console.warn("BRIDGE WARNING: Datos de sesión nativos vacíos recibidos.");
            console.log("BRIDGE: Recibiendo sesión nativa...");
            try {
                let parsedData: UserData;

                if (typeof data === 'string') {
                    const decodedJson = base64ToUtf8(data);
                    parsedData = JSON.parse(decodedJson);
                    console.log("BRIDGE: Sesión nativa decodificada:", parsedData);        
                } else {
                    parsedData = data as UserData;
                }

                if (parsedData && (parsedData.id || parsedData.username)) {
                    // Llamamos al callback del provider
                    onSessionReceived(parsedData);
                    
                    // Respondemos a Android
                    if (window.Android?.postMessage) {
                        window.Android.postMessage(JSON.stringify({ action: "SESSION_INJECTED_OK" }));
                    }
                }
            } catch (e) {
                console.error("BRIDGE ERROR:", e);
                if (window.Android?.postMessage) {
                    window.Android.postMessage(JSON.stringify({ action: "SESSION_INJECTED_ERROR", error: String(e) }));
                }
            }
        };

        return () => {
            // Limpieza al desmontar
            if (window.CarriApp) {
                window.CarriApp.injectSession = undefined;
            }
        };
    }, [onSessionReceived]);
};